import { firestoreAction } from 'vuexfire'
import { db } from '@/firebase/db'

const state = {
  inspect: [],
  disposalTypes: [
    {name: "Restavfall", dangerous: false},
    {name: "Behandlet trevirke", dangerous: false},
    {name: "CCA-impregnert trevirke*", dangerous: true},
    {name: "Metall", dangerous: false},
    {name: "Gips", dangerous: false},
    {name: "Papp", dangerous: false},
    {name: "Folieplast", dangerous: false},
    {name: "Plast blandet", dangerous: false},
    {name: "EE-avfall", dangerous: false},
    {name: "Park- og hageavfall", dangerous: false},
    {name: "Tegl og takstein", dangerous: false},
    {name: "Betong med armering", dangerous: false},
    {name: "Betong uten armering", dangerous: false},
    {name: "Rene masser", dangerous: false},
    {name: "Lett forurensede masser", dangerous: false},
    {name: "Forurensede masser", dangerous: false},
    {name: "Ftalater*", dangerous: true},
  ],
  
}

const getters = {
  list(state){
    return state.containers
  },
  types(state){
    return state.disposalTypes
  }
}

const mutations = {}

const actions = {
  add: firestoreAction(({ context }, order) => {
    console.log(context)
    
    return db.collection('disposalorders').add(order)
  }),
  

}


export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations
}